export default [
  'accounting2@foodforjoe.es',
  'mtro@tax.es',
  'antonella@foodforjoe.es',
  'laia@foodforjoe.es',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
];
